import { IResourceCard } from 'interfaces/components/resources';

interface ResourceCardProps {
  resource: IResourceCard;
  isSmScreen: boolean;
}

const ResourceCard = ({ resource, isSmScreen }: ResourceCardProps) => (
  <a
    target='_blank'
    rel='noreferrer'
    href={resource.url}
    className={`min-w-[180px] basis-[calc(50%-0.5rem)] cursor-pointer flex flex-col border-0 overflow-hidden
      ${isSmScreen ? 'flex-grow h-[240px]' : 'h-[215px]'}`}
  >
    <img
      alt='img'
      src={resource.image}
      className={`rounded-lg object-contain
        ${isSmScreen ? 'h-[150px]' : 'h-[135px]'}`}
    />
    <div className='max-w-[250px] mx-auto py-3'>
      <p className='text-base font-light line-clamp-3'>{resource.text}</p>
    </div>
  </a>
);

export default ResourceCard;
